$(document).ready(function(){
  
  
  $('#mobileMenu').mmenu({
    classes:"mm-white",
    position:"right"
  });
  
  
  $('a[href^="#"]').bind('click.smoothscroll',function (e) {

      e.preventDefault();

      var target = this.hash,
          $target = $(target);

      $('html, body').stop().animate({
          'scrollTop': $target.offset().top
      }, 500, 'swing', function () {
          window.location.hash = target;
      });
    
  });
  
  
  $('.mobileThumbs a').click(function(){
    $(this).parents('.productContainer').find('.featuredImage img').attr('src', $(this).attr('data-original-image'));
    return false;
  });
  
  
  $('.optionsPreview a').click( function() { 
    $(this).parents('.gridItem').find('.image img').attr('src', $(this).attr('href'));
    $(this).parents('.gridItem').find('.updateFlavor').text($(this).attr('title'));
    $(this).parents('.gridItem').find('.price').html($(this).attr('data-price'));
    $(this).parents('li').addClass('selected').siblings('li').removeClass('selected');
    return false;
  });

  
  $('input[type="submit"], input.btn, button').click(function(){ // remove ugly outline on input button click
    $(this).blur();
  });
  
  /* Slide Toggle */
  
  $('a.triggerSlideToggle').click( function() { 
    var target = $(this).attr('target');
    $(target).slideToggle(200);
  });
  
  
  /* Titles Toggle Next Element */
  
  $('.titlesToggle > h4').next().hide();
  /* $('.titlesToggle > h4').first().next().show(); */
  $('.titlesToggle > h4').click(function() { 
    $(this).next().slideToggle(100);
    $(this).siblings('h4').next().slideUp(100);
  });
  
  
  /** Popups **/
  
  $('#blackBack,.popup a.close,.popup a.closeX').click( function() { 
    $('#blackBack').hide();
    $('.popup').hide();
  });
  
  function popupInCenter(target) { 
    $('#blackBack').show();
    $(target).css({'max-height':($(window).height()-100+'px')});
    $(target).show().position({
      my:'center center',
      at:'center center',
      of:window
    });
  }
  
  $('.triggerPopup').click( function() { 
    if($(this).attr('data-target')) {
      var target = $(this).attr('data-target');
    } else { 
      var target = $(this).attr('target');
    }
    popupInCenter(target);
  });
  
  
  
  

}); /*** End document.ready ***/